import useAppStoreContext from "../../../shared/context/app-store/app-store.context";
import IAsyncArgs from "../../../shared/contracts/IAsyncArgs";
import IAvailableColumnsFetchBody from "../../../shared/contracts/IAvailableColumnsFetchBody";
import IDataSourceProps from "../../../shared/contracts/IDataSourceProps";
import IException from "../../../shared/contracts/IException";
import IFilterOptionsProps from "../../../shared/contracts/IFilterOptionsProps";
import IReportColumnResponse from "../../../shared/contracts/IReportColumnResponse";
import IReportDataBody from "../../../shared/contracts/IReportDataBody";
import { IReportDataOptionsResponse } from "../../../shared/contracts/IReportDataOptions";
import IReportFilterCriteria from "../../../shared/contracts/IReportFilterCriteria";
import IReportName from "../../../shared/contracts/IReportName";
import IReportSaveFiltersBody from "../../../shared/contracts/IReportSaveFiltersBody";
import IReportSaveSelectedColumnsBody from "../../../shared/contracts/IReportSaveSelectedColumnsBody";
import { IRowData } from "../../../shared/contracts/IRowData";
import IReportSelectedColumn from "../../../shared/contracts/IReportSelectedColumn";
import { IWizardReportDetailsResponse } from "../../../shared/contracts/IWizardReportDetailsResponse";
import useHelpers from "../../../shared/services/helpers/useHelpers.hook";
import useApi from "../../../shared/services/useApi.hook";
import { IWizardDetailsPostBody } from "../../components/report-details-wizard/contracts/IWizardDetailsPostBody";
import * as createReportComponentService from "./create-report-dialog/create-report.component.service";


function useReportingAndAnalyticsApi() {

  const { NORMALIZE_KEYS } = useHelpers();
  const { selReportCode } = useAppStoreContext();
  const CREATE_REPORT_SUBSCRIPTION = 'CreateReportSubscription';
  const REPORT = 'Report';
  const ADVANCE_SEARCH = 'AdvanceSearch';
  const BASE_URL: string = `${process.env.REACT_APP_BASE_URL}`;

  const {
    GET, POST, DELETE,
    TENANT_ID, ALL_REPORTS_EP, REPORT_DATA_EP, SELECTED_COLUMNS_EP, AVAILABLE_COLUMNS_EP,
    DEFAULT_FILTERS_EP, SAVE_SELECTED_COLUMNS_EP, SAVE_FILTERS_EP, DATASOURCES_EP, FILTER_OPTIONS_EP, GROUP_BY_OPTIONS_EP, FORMAT_OPTIONS_EP,
    SAVE_REPORT_DATA_EP, REPORT_DETAILS_EP } = useApi();

  //GET CALLS SECTION
  const getReportList = (
    { doIf,
      doBefore = () => { },
      doAfter = () => { },
      onFulfilled,
      onException = (exception: any) => { console.warn('exception', exception); },
    }: IAsyncArgs<IReportName[]>
  ): void => {

    if (doIf()) {
      GET<IReportName[]>(`${BASE_URL}/${REPORT}/${ALL_REPORTS_EP}/${TENANT_ID}`,
        doBefore,
        (fulfilled) => onFulfilled(fulfilled),
        (rejection) => onException(rejection),
        (exception) => onException(exception),
        doAfter
      );
    }
  }

  const getSelectedColumns = (
    { doIf,
      doBefore = () => { },
      doAfter = () => { },
      onFulfilled,
      onException = (exception: any) => { console.warn('exception', exception); },
    }: IAsyncArgs<IReportSelectedColumn[]>
  ): void => {

    if (doIf()) {
      GET<IReportSelectedColumn[]>(`${BASE_URL}/${REPORT}/${SELECTED_COLUMNS_EP}/${TENANT_ID}/${selReportCode}`,
        doBefore,
        (fulfilled) => onFulfilled(fulfilled),
        (rejection) => onException(rejection),
        (exception) => onException(exception),
        doAfter
      );
    }
  }

  const getAvailableColumns = (getBody: IAvailableColumnsFetchBody,
    { doIf,
      doBefore = () => { },
      doAfter = () => { },
      onFulfilled,
      onException = (exception: any) => { console.warn('exception', exception); },
    }: IAsyncArgs<IReportColumnResponse>
  ): void => {

    if (doIf()) {
      GET<IReportColumnResponse>(`${BASE_URL}/${REPORT}/${AVAILABLE_COLUMNS_EP}/${TENANT_ID}?` + new URLSearchParams(getBody),
        doBefore,
        (fulfilled) => onFulfilled(fulfilled),
        (rejection) => onException(rejection),
        (exception) => onException(exception),
        doAfter
      );
    }
  }

  const getFilters = (
    { doIf,
      doBefore = () => { },
      doAfter = () => { },
      onFulfilled,
      onException = (exception: any) => { console.warn('exception', exception); },
    }: IAsyncArgs<IReportFilterCriteria[]>
  ): void => {

    if (doIf()) {
      GET<IReportFilterCriteria[]>(`${BASE_URL}/${REPORT}/${DEFAULT_FILTERS_EP}/${TENANT_ID}/${selReportCode}`,
        doBefore,
        (fulfilled) => onFulfilled(fulfilled),
        (rejection) => onException(rejection),
        (exception) => onException(exception),
        doAfter
      );
    }
  }

  const getReportData = (postBody: IReportDataBody,
    { doIf,
      doBefore = () => { },
      doAfter = () => { },
      onFulfilled,
      onException = (exception: any) => { console.warn('exception', exception); },
    }: IAsyncArgs<any>
  ): void => {


    if (doIf()) {
      POST<IReportDataBody, any>(`${BASE_URL}/${REPORT}/${REPORT_DATA_EP}/${TENANT_ID}/${selReportCode}`,
        postBody,
        doBefore,
        (fulfilled) => onFulfilled(fulfilled?.table1), //TODO: check the Table1 Props purpose with naval
        (rejection) => onException(rejection),
        (exception) => onException(exception),
        doAfter
      );
    }
  }

  const getDatasourceList = (
    { doIf,
      doBefore = () => { },
      doAfter = () => { },
      onFulfilled,
      onException = (exception: any) => { console.warn('exception', exception); },
    }: IAsyncArgs<IDataSourceProps[]>
  ): void => {

    if (doIf()) {
      GET<IDataSourceProps[]>(`${BASE_URL}/${REPORT}/${DATASOURCES_EP}/${TENANT_ID}`,
        doBefore,
        (fulfilled) => onFulfilled(fulfilled),
        (rejection) => onException(rejection),
        (exception) => onException(exception),
        doAfter
      );
    }
  }

  const getFilterOperatorsList = (
    { doIf,
      doBefore = () => { },
      doAfter = () => { },
      onFulfilled,
      onException = (exception: any) => { console.warn('exception', exception); },
    }: IAsyncArgs<IFilterOptionsProps>
  ): void => {

    if (doIf()) {
      GET<IFilterOptionsProps>(`${BASE_URL}/${ADVANCE_SEARCH}/${FILTER_OPTIONS_EP}`,
        doBefore,
        (fulfilled) => onFulfilled(fulfilled),
        (rejection) => onException(rejection),
        (exception) => onException(exception),
        doAfter
      );
    }
  }

  const saveSelectedColumns = (postBody: IReportSaveSelectedColumnsBody,
    { doIf,
      doBefore = () => { },
      doAfter = () => { },
      onFulfilled,
      onException = (exception: any) => { console.warn('exception', exception); },
    }: IAsyncArgs<any>
  ): void => {

    if (doIf()) {
      POST<IReportSaveSelectedColumnsBody, any>(`${BASE_URL}/${REPORT}/${SAVE_SELECTED_COLUMNS_EP}/${TENANT_ID}/${selReportCode}`,
        postBody,
        doBefore,
        (fulfilled) => onFulfilled(fulfilled),
        (rejection) => onException(rejection),
        (exception) => onException(exception),
        doAfter
      );
    }
  }

  const saveFilters = (postBody: IReportSaveFiltersBody,
    { doIf,
      doBefore = () => { },
      doAfter = () => { },
      onFulfilled,
      onException = (exception: any) => { console.warn('exception', exception); },
    }: IAsyncArgs<any>
  ): void => {

    if (doIf()) {
      POST<IReportSaveFiltersBody, any>(`${BASE_URL}/${REPORT}/${SAVE_FILTERS_EP}/${TENANT_ID}/${selReportCode}`,
        postBody,
        doBefore,
        (fulfilled) => onFulfilled(fulfilled),
        (rejection) => onException(rejection),
        (exception) => onException(exception),
        doAfter
      );
    }
  }

  const saveReportDetails = (postBody: createReportComponentService.IReportSaveData,
    { doIf,
      doBefore = () => { },
      doAfter = () => { },
      onFulfilled,
      onException = (exception: any) => { console.warn('exception', exception); },
    }: IAsyncArgs<any>
  ): void => {

    if (doIf()) {
      POST<createReportComponentService.IReportSaveData, any>(`${BASE_URL}/${REPORT}/${SAVE_REPORT_DATA_EP}/${TENANT_ID}`,
        postBody,
        doBefore,
        (fulfilled) => onFulfilled(fulfilled),
        (rejection) => onException(rejection),
        (exception) => onException(exception),
        doAfter
      );
    }
  }

  const deleteReport = (reportId: number, owner: string, {
    doBefore = () => { },
    doAfter = () => { },
    onFulfilled,
    onException = (exception: IException) => { console.warn('Exception during delete Report:', exception); }
  }: IAsyncArgs<void>) => {

    DELETE(
      `${BASE_URL}/${REPORT}/DeleteReport/${TENANT_ID}/${reportId}/${owner}`,
      doBefore,
      onFulfilled,
      (rejection) => onException(rejection),
      onException,
      doAfter
    );
  };


  const saveReportSubscription = (postBody: IRowData,
    { doIf,
      doBefore = () => { },
      doAfter = () => { },
      onFulfilled,
      onException = (exception: any) => { console.warn('exception', exception); },
    }: IAsyncArgs<any>
  ): void => {

    if (doIf()) {
      POST<IRowData, any>(`${BASE_URL}/${REPORT}/${CREATE_REPORT_SUBSCRIPTION}/${TENANT_ID}`,
        postBody,
        doBefore,
        (fulfilled) => onFulfilled(fulfilled),
        (rejection) => onException(rejection),
        (exception) => onException(exception),
        doAfter
      );
    }
  }


  const getWizardReportDetails = (
    reportCode: string,
    {
      doIf,
      doBefore = () => { },
      doAfter = () => { },
      onFulfilled,
      onException = (exception: any) => { console.warn('exception', exception); },
    }: IAsyncArgs<IWizardReportDetailsResponse>
  ): void => {

    if (doIf()) {
      GET<IWizardReportDetailsResponse>(`${BASE_URL}/${REPORT_DETAILS_EP}/${TENANT_ID}/${reportCode}`,
        doBefore,
        (fulfilled) => onFulfilled(fulfilled),
        (rejection) => onException(rejection),
        (exception) => onException(exception),
        doAfter
      );
    }
  }

  const saveWizardReportDetails = (postBody: IWizardDetailsPostBody, //
    { doIf,
      doBefore = () => { },
      doAfter = () => { },
      onFulfilled,
      onException = (exception: any) => { console.warn('exception', exception); },
    }: IAsyncArgs<any>
  ): void => {

    if (doIf()) {
      POST<IWizardDetailsPostBody, any>(`${BASE_URL}/${REPORT}/${SAVE_REPORT_DATA_EP}/${TENANT_ID}`,
        postBody,
        doBefore,
        (fulfilled) => onFulfilled(fulfilled),
        (rejection) => onException(rejection),
        (exception) => onException(exception),
        doAfter
      );
    }
  }



  const getFilterOptions = (
    { doIf,
      doBefore = () => { },
      doAfter = () => { },
      onFulfilled,
      onException = (exception: any) => { console.warn('exception', exception); },
    }: IAsyncArgs<IReportDataOptionsResponse>
  ): void => {

    if (doIf()) {
      GET<IReportDataOptionsResponse>(`${BASE_URL}/${ADVANCE_SEARCH}/${FILTER_OPTIONS_EP}`,
        doBefore,
        (fulfilled) => onFulfilled(fulfilled),
        (rejection) => onException(rejection),
        (exception) => onException(exception),
        doAfter
      );
    }
  }

  const getGroupByOptions = (
    { doIf,
      doBefore = () => { },
      doAfter = () => { },
      onFulfilled,
      onException = (exception: any) => { console.warn('exception', exception); },
    }: IAsyncArgs<IReportDataOptionsResponse>
  ): void => {

    if (doIf()) {
      GET<IReportDataOptionsResponse>(`${BASE_URL}/${ADVANCE_SEARCH}/${GROUP_BY_OPTIONS_EP}`,
        doBefore,
        (fulfilled) => onFulfilled(fulfilled),
        (rejection) => onException(rejection),
        (exception) => onException(exception),
        doAfter
      );
    }
  }

  const getFormatOptions = (
    { doIf,
      doBefore = () => { },
      doAfter = () => { },
      onFulfilled,
      onException = (exception: any) => { console.warn('exception', exception); },
    }: IAsyncArgs<IReportDataOptionsResponse>
  ): void => {

    if (doIf()) {
      GET<IReportDataOptionsResponse>(`${BASE_URL}/${ADVANCE_SEARCH}/${FORMAT_OPTIONS_EP}`,
        doBefore,
        (fulfilled) => onFulfilled(fulfilled),
        (rejection) => onException(rejection),
        (exception) => onException(exception),
        doAfter
      );
    }
  }




  // ---
  return {

    getReportList,
    getReportData,
    getFilters,
    getSelectedColumns,
    getDatasourceList,
    getAvailableColumns,
    getFilterOperatorsList,
    saveFilters,
    saveSelectedColumns,
    saveReportDetails,
    saveReportSubscription,
    deleteReport,
    // ---wizard
    getFilterOptions, getGroupByOptions, getFormatOptions,
    getWizardReportDetails,
    saveWizardReportDetails,

  }

}
export default useReportingAndAnalyticsApi;